import { render, staticRenderFns } from "./rightBoard.vue?vue&type=template&id=b52505b4&scoped=true"
import script from "./rightBoard.vue?vue&type=script&lang=js"
export * from "./rightBoard.vue?vue&type=script&lang=js"
import style0 from "./rightBoard.vue?vue&type=style&index=0&id=b52505b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b52505b4",
  null
  
)

export default component.exports